import { colors } from "./colors";
import { fonts } from "./fonts";
import { spaces } from "./spaces";
import { radius } from "./radius";
import { breakpoints, mq } from "./breakpoints";
import { layout } from "./layout";
import { type } from "./type";

export const theme = {
  colors,
  fonts,
  type,
  spaces,
  radius,
  breakpoints,
  mq,
  layout,
} as const;

export type Theme = {
  theme: typeof theme;
};
